import { Component, Input, OnDestroy } from '@angular/core';
import { GrundstueckListEntry } from '../../../core/gb-api';
import { TranslateService } from '@ngx-translate/core';
import { LinkComponent, NavTarget } from '../../components/link/link.component';
import { Subscription } from 'rxjs';
import { NgTemplateOutlet } from '@angular/common';
import { GrundstuecknummerPipe } from '../../pipes/simple/grundstuecknummer.pipe';
import { KompaktGrundstueckPipe } from './kompakt-grundstueck.pipe';

@Component({
  selector: 'cap-kompakt-grundstueck',
  templateUrl: './kompakt-grundstueck.component.html',
  styleUrls: ['./kompakt-grundstueck.component.scss'],
  preserveWhitespaces: false,
  imports: [LinkComponent, NgTemplateOutlet, GrundstuecknummerPipe, KompaktGrundstueckPipe]
})
export class KompaktGrundstueckComponent implements OnDestroy {
  navTargets = NavTarget;

  @Input() item: GrundstueckListEntry;
  protected language: string;

  @Input()
  navigateTo = NavTarget.NAV_GRUNDSTUECK;

  private subscription: Subscription;

  constructor(private translateService: TranslateService) {
    this.subscription = this.translateService.onLangChange.subscribe((language) => {
      this.language = language.lang;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
